export default "__VITE_ASSET__D51$RU54__"